import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "counter", "submitButton"]
  
  connect() {
    this.selectedFields = new Set()
    this.updateUI()
  }
  
  toggleField(event) {
    event.preventDefault()
    const fieldElement = event.currentTarget
    const fieldType = fieldElement.dataset.fieldType
    
    if (this.selectedFields.has(fieldType)) {
      this.selectedFields.delete(fieldType)
      fieldElement.classList.remove('selected')
    } else {
      this.selectedFields.add(fieldType)
      fieldElement.classList.add('selected')
    }
    
    this.updateUI()
  }
  
  updateUI() {
    // Update counter
    const count = this.selectedFields.size
    this.counterTarget.textContent = `${count} field${count !== 1 ? 's' : ''} selected`
    
    // Enable/disable submit button
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = count === 0
    }
  }
  
  addSelectedFields(event) {
    event.preventDefault()
    
    if (this.selectedFields.size === 0) {
      return
    }
    
    // Get the form-builder controller
    const formBuilderController = this.application.getControllerForElementAndIdentifier(
      this.element,
      'form-builder'
    )
    
    if (formBuilderController) {
      // Add each selected field
      this.selectedFields.forEach(fieldType => {
        formBuilderController.addFieldByType(fieldType)
      })
    }
    
    // Clear selections
    this.selectedFields.clear()
    this.fieldTargets.forEach(field => {
      field.classList.remove('selected')
    })
    this.updateUI()
    
    // Close the modal
    const modal = bootstrap.Modal.getInstance(this.element)
    if (modal) {
      modal.hide()
    }
  }
}